import { credits_png } from "@/assets/images";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { useUserStore } from "@/stores";

const RemainCredits = () => {
  const { t } = useTranslation();
  const credits = useUserStore(state => state.credits);

  if (typeof credits === "number") {
    return (
      <span
        className={styles["remain_credits"]}
      >
        <img 
          className={styles["credits_img"]}
          src={credits_png}
          alt="" 
          width={16}
          height={16}
        />
        <span
          className={styles["credits"]}
        >
          {t("remain_credits")}
          {credits}
        </span>
      </span>
    )
  } 
  return null;
}

export default RemainCredits;